import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const SowAddendumRequiredDialog = ({
  open,
  title = 'Create SOW Addendum',
  description = 'SOW is signed. Create a SOW Addendum to add or update milestones.',
  loading = false,
  onCancel,
  onProceed,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      if (!loading) {
        onCancel?.();
      }
    }}
    aria-labelledby='addendum-required-dialog-title'
    maxWidth='sm'
    fullWidth
  >
    <DialogTitle
      id='addendum-required-dialog-title'
      sx={{ fontSize: '1.25rem', fontWeight: 600 }}
    >
      {title}
    </DialogTitle>
    <DialogContent>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <InfoOutlinedIcon sx={{ color: '#2563EB', fontSize: '1.25rem', mt: 0.25 }} />
        <Typography variant='body2' sx={{ fontSize: '0.875rem' }}>
          {description}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={onProceed}
        variant='contained'
        color='primary'
        disabled={loading}
      >
        Proceed
      </Button>
    </DialogActions>
  </Dialog>
);

export default SowAddendumRequiredDialog;
